/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const csRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Žádost o přidání školy',
    description: 'Vyplňte prosím formulář níže. Není zaručeno, že budou předložené školy přidány, ale všechny žádosti jsou prozkoumány a zváženy pomocí SheerID. ',
    noCountry: 'Nevidíte zemi vaší školy? Na tuto nabídku nemáte nárok',
    searchByOrgName: 'Nevidíte svou školu? Hledat podle názvu',
    completeRequest: 'Nevidíte svou školu na seznamu způsobilých nebo nezpůsobilých škol? Dokončete žádost',
    submit: 'Podat',
    eligibleOrgs: 'Způsobilé školy. Klikněte na ikonku pro zkopírování názvu a poté se navraťte do ověřovacího formuláře',
    ineligibleOrgs: 'Nezpůsobilé školy. Je nám líto, ale studenti na těchto školách nemají na tuto nabídku nárok',
    none: 'Ani jedno',
    country: 'Kam chodíte do školy?',
    changeLanguage: 'Změnit jazyk',
    copied: 'Zkopírováno',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    emailAddress: 'Emailová adresa',
    poweredBy: 'Ověřovací služba zpracována pomocí SheerID',
    fields: {
        countryPlaceholder: 'Vyberte zemi',
        domainLabel: 'Webové stránky školy',
        domainPlaceholder: 'www.mojeskola.cz',
        orgNameLabel: 'Název školy',
        orgNamePlaceholder: 'Moje škola',
    },
    step: {
        success: {
            title: 'Děkujeme za podání žádosti pro vaši školu',
            description: 'Připomínáme, že každá žádost je vyhodnocena na základě SheerID a požadavků stanovených v této nabídce. Neexistuje žádná záruka, že vaše škola bude přidána. Proces vyhodnocení může trvat až 7 dní.',
        },
        error: {
            title: 'Došlo k neočekávané chybě',
            description: 'Omlouváme se, ale vaši žádost nejsme schopni zpracovat. Zkuste to prosím později.',
            seeingProblem: 'Pokud potíže přetrvávají,',
            contactUs: 'kontaktujte nás',
        },
    },
    errorId: {
        invalidCountry: 'Pole je povinné',
        invalidEmail: 'Neplatný e-mail',
        invalidFirstName: 'Neplatné křestní jméno',
        invalidLastName: 'Neplatné příjmení',
        requiredField: 'Pole je povinné',
        invalidField: 'Pole je neplatné',
        invalidUrl: 'Neplatná adresa URL',
        tooManyResults: 'Pro vaše vyhledávání bylo nalezeno příliš mnoho výsledků. Vyhledávání prosím upřesněte a zkuste to znovu',
    },
    faq: 'Časté dotazy k SheerID žádosti o přidání školy',
    countries: {
        AD: ' Andorra',
        AE: 'Spojené arabské emiráty',
        AF: 'Afghánistán',
        AG: 'Antigua a Barbuda',
        AI: 'Anguilla',
        AL: 'Albánie',
        AM: 'Arménie',
        AN: 'Nizozemské Antily',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'Americká Samoa',
        AT: 'Rakousko',
        AU: 'Austrálie',
        AW: 'Aruba',
        AZ: 'Ázerbajdžán',
        BA: 'Bosna a Hercegovina',
        BB: 'Barbados',
        BD: 'Bangladéš',
        BE: 'Belgie',
        BF: 'Burkina Faso',
        BG: 'Bulharsko',
        BH: 'Bahrajn',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermudy',
        BN: 'Brunej Darussalam',
        BO: 'Bolívie',
        BR: 'Brazílie',
        BS: 'Bahamy',
        BT: 'Bhútán',
        BV: 'Bouvetův ostrov',
        BW: 'Botswana',
        BY: 'Bělorusko',
        BZ: 'Belize',
        CA: 'Kanada',
        CD: 'Demokratická republika Kongo',
        CF: 'Středoafrická republika',
        CG: 'Kongo',
        CH: 'Švýcarsko',
        CI: 'Pobřeží slonoviny (Cote D\'Ivoire)',
        CK: 'Cookovy ostrovy',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'Čína',
        CO: 'Kolumbie',
        CR: 'Kostarika',
        CU: 'Kuba',
        CV: 'Kapverdy',
        CY: 'Kypr',
        CZ: 'Česká republika',
        DE: 'Německo',
        DJ: 'Džibutsko',
        DK: 'Dánsko',
        DM: 'Dominika',
        DO: 'Dominikánská republika',
        DZ: 'Alžírsko',
        EC: 'Ekvádor',
        EE: 'Estonsko',
        EG: 'Egypt',
        EH: 'Západní Sahara',
        ER: 'Eritrea',
        ES: 'Španělsko',
        ET: 'Etiopie',
        FI: 'Finsko',
        FJ: 'Fidži',
        FK: 'Falklandy',
        FM: 'Mikronésie',
        FO: 'Faerské ostrovy',
        FR: 'Francie',
        GA: 'Gabon',
        GB: 'Spojené království',
        GD: 'Grenada',
        GE: 'Gruzie',
        GF: 'Francouzská Guyana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grónsko',
        GM: 'Gambie',
        GN: 'Guinea',
        GP: 'Guadeloupe (Francie)',
        GQ: 'Rovníková Guinea',
        GR: 'Řecko',
        GS: 'Jižní Georgie a Jižní Sandwichovy ostrovy',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea Bissau',
        GY: 'Guyana',
        HK: 'Hongkong',
        HM: 'Heard a McDonaldovy ostrovy',
        HN: 'Honduras',
        HR: 'Chorvatsko',
        HT: 'Haiti',
        HU: 'Maďarsko',
        ID: 'Indonésie',
        IE: 'Irsko',
        IL: 'Izrael',
        IN: 'Indie',
        IO: 'Britské území v Indickém oceánu',
        IQ: 'Irák',
        IR: 'Írán',
        IS: 'Island',
        IT: 'Itálie',
        JM: 'Jamaica',
        JO: 'Jordán',
        JP: 'Japonsko',
        KE: 'Keňa',
        KG: 'Kyrgyzstán',
        KH: 'Kambodža',
        KI: 'Kiribati',
        KM: 'Komory',
        KN: 'Svatý Kryštof, Nevis a Anguilla',
        KP: 'Severní Korea',
        KR: 'Jižní Korea',
        KW: 'Kuvajt',
        KY: 'Kajmanské ostrovy',
        KZ: 'Kazachstán',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'Svatá Lucia',
        LI: 'Lichtenštejnsko',
        LK: 'Srí Lanka',
        LR: 'Libérie',
        LS: 'Lesotho',
        LT: 'Litva',
        LU: 'Lucembursko',
        LV: 'Lotyšsko',
        LY: 'Libye',
        MA: 'Maroko',
        MC: 'Monako',
        MD: 'Moldavsko',
        ME: 'Černá Hora',
        MG: 'Madagaskar',
        MH: 'Marshallovy ostrovy',
        MK: 'Makedonie',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolsko',
        MO: 'Macau',
        MP: 'Severní Mariany',
        MQ: 'Martinik (francie)',
        MR: 'Mauritánie',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauricius',
        MV: 'Maledivy',
        MW: 'Malawi',
        MX: 'Mexiko',
        MY: 'Malajsie',
        MZ: 'Mozambik',
        NA: 'Namibie',
        NC: 'Nová Kaledonie (Francie)',
        NE: 'Niger',
        NF: 'Norfolk (ostrov)',
        NG: 'Nigérie',
        NI: 'Nikaragua',
        NL: 'Holandsko',
        NO: 'Norsko',
        NP: 'Nepál',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nový Zéland',
        OM: 'Omán',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynésie (Francie)',
        PG: 'Papua-Nová Guinea',
        PH: 'Filipíny',
        PK: 'Pákistán',
        PL: 'Polsko',
        PM: 'Saint-Pierre a Miquelon',
        PN: 'Pitcairnovy ostrovy',
        PR: 'Portoriko',
        PS: 'Palestina',
        PT: 'Portugalsko',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Katar',
        RE: 'Réunion (Francie)',
        RO: 'Rumunsko',
        RS: 'Srbsko',
        RU: 'Ruská Federace',
        RW: 'Rwanda',
        SA: 'Saudská arábie',
        SB: 'Solomonovy ostrovy',
        SC: 'Seychely',
        SD: 'Súdán',
        SE: 'Švédsko',
        SG: 'Singapur',
        SH: 'Svatá Helena',
        SI: 'Slovinsko',
        SK: 'Slovenská republika',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somálsko',
        SR: 'Surinam',
        SS: 'jižní Súdán',
        ST: 'Svatý Tomáš a Princův ostrov',
        SV: 'El Salvador',
        SY: 'Sýrie',
        SZ: 'Svazijsko',
        TC: 'ostrovy Turks a Caicos',
        TD: 'Čad',
        TF: 'Francouzská jižní území',
        TG: 'Togo',
        TH: 'Thajsko',
        TJ: 'Tádžikistán',
        TK: 'Tokelau',
        TL: 'Timor-Leste',
        TM: 'Turkmenistán',
        TN: 'Tunisko',
        TO: 'Tonga',
        TR: 'Turecko',
        TT: 'Trinidad a Tobago',
        TV: 'Tuvalu',
        TW: 'Tchaj-wan',
        TZ: 'Tanzanie',
        UA: 'Ukrajina',
        UG: 'Uganda',
        UM: 'Menší odlehlé ostrovy USA',
        US: 'Spojené státy',
        UY: 'Uruguay',
        UZ: 'Uzbekistán',
        VA: 'Městský stát Vatikán',
        VC: 'Svatý Vincenc a Grenadiny',
        VE: 'Venezuela',
        VG: 'Britské Panenské ostrovy',
        VI: 'Panenské ostrovy (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'ostrovy Wallis a Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: 'Jižní Afrika',
        ZM: 'Zambie',
        ZW: 'Zimbabwe',
    },
    locales: {
        ar: ' arabština',
        bg: 'bulharština',
        cs: 'čeština',
        da: 'dánština',
        de: 'němčina',
        el: 'řečtina',
        'en-GB': 'angličtina (Velká Británie)',
        'en-US': 'angličtina',
        'es-ES': 'španělština (Španělsko)',
        es: 'španělština',
        fi: 'finština',
        'fr-CA': 'francouzština (Kanada)',
        fr: 'francouzština',
        hr: 'chorvatština',
        hu: 'maďarština',
        id: 'indonéština',
        is: 'islandština',
        it: 'italština',
        iw: 'hebrejština',
        ja: 'japonština',
        ko: 'korejština',
        lt: 'litevština',
        ms: 'malajština',
        nl: 'holandština',
        no: 'norština',
        pl: 'polština',
        'pt-BR': 'portugalština (Brazílie)',
        pt: 'portugalština',
        ro: 'rumunština',
        ru: 'Rusko',
        sk: 'slovenština',
        sl: 'slovinština',
        sr: 'srbština',
        sv: 'švédština',
        tr: 'turečtina',
        'zh-HK': 'čínština (Hongkong)',
        zh: 'čínština (tradiční)',
    },
};
